import { PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';
import { twMerge } from 'tailwind-merge';

import { useBodyLock } from '@/app/shared/hooks/useBodyLock';
import { useEscModalClose } from '@/app/shared/hooks/useEscModalClose';

export interface ModalProps extends PropsWithChildren {
  isOpen?: boolean;
  onClose?: () => void;
  className?: string;
}

export const Modal = ({ children, isOpen, onClose, className }: ModalProps) => {
  useBodyLock(!!isOpen);
  useEscModalClose(isOpen ? onClose : undefined);

  if (!isOpen) return null;

  return createPortal(
    <div
      className='fixed inset-0 z-50 flex items-center justify-center bg-[var(--modal-overlay)] px-5 py-10'
      onClick={onClose}
    >
      <div
        className={twMerge('w-full max-w-100 rounded-xl border border-modal-border bg-modal-bg', className)}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>,
    document.body,
  );
};
